/**
 * Özel not sayfası — /n/:slug. Sidebar'da YOK, başlık haritasında YOK.
 * İçerik pakete gömülmez, /api/ozel-notlar/:slug'dan gelir (backend e-posta kilitli).
 * Rastgele slug burada ya da App.js'te geçmez, sadece data/ozel-notlar/ dosya adında.
 */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const API_KOK = (() => {
  const ham = (process.env.REACT_APP_API_URL || 'https://api.glowytics.com').trim();
  return ham.replace(/\/+$/, '').replace(/\/api$/, '');
})();

const T = {
  zemin: '#F6F8FF', kart: '#FFFFFF', cizgi: '#E5E7EB', cizgi2: '#F3F4F6',
  metin: '#111827', metin2: '#374151', metin3: '#6B7280', mavi: '#436AEB',
};

// **kalın** + çıplak URL — başka biçim yok.
function Satir({ metin }) {
  const parcalar = String(metin).split(/(\*\*[^*]+\*\*|https?:\/\/\S+)/g);
  return parcalar.map((p, i) => {
    if (p.startsWith('**') && p.endsWith('**')) return <strong key={i} style={{ color: T.metin }}>{p.slice(2, -2)}</strong>;
    if (/^https?:\/\//.test(p)) {
      const temiz = p.replace(/[).,]+$/, '');
      return <a key={i} href={temiz} target="_blank" rel="noreferrer" style={{ color: T.mavi }}>{temiz}</a>;
    }
    return <React.Fragment key={i}>{p}</React.Fragment>;
  });
}

function Tablo({ tablo }) {
  return (
    <div style={{ overflowX: 'auto' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
        <thead>
          <tr>
            {tablo.sutunlar.map((s) => (
              <th key={s} style={{ textAlign: 'left', padding: '8px 10px', color: T.metin3, fontWeight: 600, borderBottom: `1px solid ${T.cizgi}`, whiteSpace: 'nowrap' }}>{s}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tablo.satirlar.map((r, i) => (
            <tr key={i}>
              {r.map((h, j) => (
                <td key={j} style={{ padding: '8px 10px', borderBottom: `1px solid ${T.cizgi2}`, color: j === 1 ? T.metin : T.metin2, verticalAlign: 'top' }}>
                  <Satir metin={h} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function OzelNot() {
  const { slug } = useParams();
  const [veri, setVeri] = useState(null);
  const [hata, setHata] = useState(null);
  const [hamAcik, setHamAcik] = useState(false);

  useEffect(() => {
    let iptal = false;
    fetch(`${API_KOK}/api/ozel-notlar/${encodeURIComponent(slug)}`, { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('Bulunamadı'))))
      .then((j) => { if (!iptal) setVeri(j); })
      .catch((e) => { if (!iptal) setHata(e.message); });
    return () => { iptal = true; };
  }, [slug]);

  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => { document.head.removeChild(meta); };
  }, []);

  useEffect(() => { if (veri?.baslik) document.title = veri.baslik; }, [veri]);

  if (hata) return <div style={{ padding: 40, color: T.metin3, fontFamily: 'Inter, system-ui, sans-serif' }}>Sayfa bulunamadı.</div>;
  if (!veri) return <div style={{ padding: 40, color: T.metin3, fontFamily: 'Inter, system-ui, sans-serif' }}>Yükleniyor…</div>;

  const kart = { background: T.kart, border: `1px solid ${T.cizgi}`, borderRadius: 12, padding: '20px 22px', marginBottom: 16 };

  return (
    <div style={{ minHeight: '100vh', background: T.zemin, fontFamily: 'Inter, system-ui, sans-serif', color: T.metin2 }}>
      <div style={{ maxWidth: 1040, margin: '0 auto', padding: '32px 16px 64px' }}>
        <div style={{ fontSize: 13, color: T.metin3, marginBottom: 4 }}>{veri.tarih}</div>
        <h1 style={{ fontSize: 26, fontWeight: 700, color: T.metin, margin: '0 0 24px' }}>{veri.baslik}</h1>

        {veri.toplantilar.map((t) => (
          <section key={t.ad} style={{ marginBottom: 28 }}>
            <h2 style={{ fontSize: 20, fontWeight: 700, color: T.metin, margin: '0 0 10px' }}>{t.ad}</h2>
            {t.not && <p style={{ margin: '0 0 12px', fontSize: 15 }}><Satir metin={t.not} /></p>}
            {t.bolumler.map((b) => (
              <div key={b.baslik} style={kart}>
                <h3 style={{ fontSize: 15, fontWeight: 600, color: T.metin, margin: '0 0 10px' }}>{b.baslik}</h3>
                {b.tablo && <Tablo tablo={b.tablo} />}
                {b.maddeler && (
                  <ul style={{ margin: 0, paddingLeft: 20, lineHeight: 1.6, fontSize: 14 }}>
                    {b.maddeler.map((m, i) => <li key={i} style={{ marginBottom: 6 }}><Satir metin={m} /></li>)}
                  </ul>
                )}
              </div>
            ))}
          </section>
        ))}

        {veri.siradaki?.length > 0 && (
          <div style={{ ...kart, borderColor: T.mavi }}>
            <h3 style={{ fontSize: 15, fontWeight: 600, color: T.metin, margin: '0 0 10px' }}>Sıradaki işler</h3>
            <ol style={{ margin: 0, paddingLeft: 20, lineHeight: 1.6, fontSize: 14 }}>
              {veri.siradaki.map((m, i) => <li key={i}>{m}</li>)}
            </ol>
          </div>
        )}

        {veri.hamNotlar && (
          <div style={kart}>
            <button onClick={() => setHamAcik((a) => !a)} style={{ background: 'none', border: 0, padding: 0, cursor: 'pointer', fontSize: 15, fontWeight: 600, color: T.metin }}>
              {hamAcik ? '▾' : '▸'} Ham notlar
            </button>
            {hamAcik && <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit', fontSize: 14, lineHeight: 1.6, margin: '12px 0 0' }}><Satir metin={veri.hamNotlar} /></pre>}
          </div>
        )}
      </div>
    </div>
  );
}
